import gql from 'graphql-tag'

export const isEmailRegistered = gql`
  query isEmailRegistered($email: NonEmptyString!, $token: NonEmptyString!) {
    isEmailRegistered(email: $email, token: $token)
  }
`
